import seo from './seo.vue'

export default seo
